import {Component, OnInit} from '@angular/core';
import {FileShareService} from '../../_services/api/file-share.service';
import {ShareItem} from './share-item/share-item.component';
import {itemAnimation, listAnimation} from '../../_animations/listItem';
import {forkJoin} from 'rxjs';
import {ConfirmationDialogComponent} from '../shared/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-transfers-view',
  templateUrl: './transfers-view.component.html',
  styleUrls: ['./transfers-view.component.scss'],
  animations: [listAnimation, itemAnimation]
})
export class TransfersViewComponent implements OnInit {

  loading: boolean;
  shareFiles: ShareItem[];
  currentlyShowing: string;
  currentlySelected: number;
  isAllSelected: boolean;

  constructor(private fileShare: FileShareService, private dialog: MatDialog) {
    this.loading = true;
    this.currentlyShowing = 'active';
    this.isAllSelected = false;
  }

  ngOnInit(): void {
    this.getShareFiles();
  }

  handleAction(name: string) {
    if (name === 'selectAll') {
      this.markAll(true);
    } else if (name === 'clearSelection') {
      this.markAll(false);
    } else if (name === 'revokeSelection') {
      const tokens = this.shareFiles.filter(item => item.is_selected).map( item => item.token);
      this.revoke_access(tokens);
    }
  }

  showShareFiles(name: string) {
    this.currentlyShowing = name;
    this.getShareFiles();
  }

  getShareFiles() {
    this.loading = true;
    this.currentlySelected = 0;
    this.fileShare.get(this.currentlyShowing).subscribe(res => {
      this.loading = false;
      this.shareFiles = res;
      this.shareFiles.forEach( sf => {sf.is_selected = false;});
    });
  }

  markAll(selected: boolean) {
    this.shareFiles.forEach( doc => {
      doc.is_selected = selected;
    });
    this.checkShareItems();
  }

  checkShareItems() {
    this.isAllSelected = false;
    this.currentlySelected = 0;
    if (this.shareFiles !== undefined) {
      let allMark = true;
      this.shareFiles.forEach(
        doc => {
          if (!doc.is_selected) {
            allMark = false;
          } else {
            this.currentlySelected += 1;
          }
        }
      );
      if (allMark) {
        this.isAllSelected = true;
      }
    }
  }

  revoke_access(tokens: string[]) {
    const message = (tokens.length > 1) ? 'Are you sure, you want to revoke access for selected files?' : 'Are you sure, you want to revoke access?';
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm revoke',
        message,
        confirm: 'Revoke'
      }
    });

    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        const requests = [];
        this.loading = true;

        tokens.forEach( token => {
          requests.push(this.fileShare.revoke_access(token));
        });

        this.shareFiles = this.shareFiles.filter(item => tokens.indexOf(item.token) === -1);

        forkJoin(...requests).subscribe(
          res => {
            this.loading = false;
            this.markAll(false);
          }
        );

      }
    });
  }

}
